import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconLayers = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--layers")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M21.5530055,16.1055728 C22.046984,15.8585836 22.647657,16.0588079 22.8946462,16.5527864 C23.1416355,17.0467649 22.9414111,17.6474379 22.4474327,17.8944272 L22.4474327,17.8944272 L12.4474327,22.8944272 C12.1659052,23.0351909 11.834533,23.0351909 11.5530055,22.8944272 L11.5530055,22.8944272 L1.55300546,17.8944272 C1.05902696,17.6474379 0.858802617,17.0467649 1.10579187,16.5527864 C1.35278111,16.0588079 1.95345415,15.8585836 2.44743265,16.1055728 L2.44743265,16.1055728 L12.0002191,20.881966 Z M21.5530055,11.1055728 C22.046984,10.8585836 22.647657,11.0588079 22.8946462,11.5527864 C23.1416355,12.0467649 22.9414111,12.6474379 22.4474327,12.8944272 L22.4474327,12.8944272 L12.4474327,17.8944272 C12.1659052,18.0351909 11.834533,18.0351909 11.5530055,17.8944272 L11.5530055,17.8944272 L1.55300546,12.8944272 C1.05902696,12.6474379 0.858802617,12.0467649 1.10579187,11.5527864 C1.35278111,11.0588079 1.95345415,10.8585836 2.44743265,11.1055728 L2.44743265,11.1055728 L12.0002191,15.881966 Z M12.4474327,1.10557281 L22.4474327,6.10557281 C23.1844812,6.47409708 23.1844812,7.52590292 22.4474327,7.89442719 L12.4474327,12.8944272 C12.1659052,13.0351909 11.834533,13.0351909 11.5530055,12.8944272 L1.55300546,7.89442719 C0.815956922,7.52590292 0.815956922,6.47409708 1.55300546,6.10557281 L11.5530055,1.10557281 C11.834533,0.964809064 12.1659052,0.964809064 12.4474327,1.10557281 Z M12.0002191,3.11803399 L4.23628703,7 L12.0002191,10.881966 L19.7641511,7 L12.0002191,3.11803399 Z" id="icon--centivo--layers"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1854.000000, -636.000000)"/>
          <g id="Icon/layers">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--layers"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--layers"/>
          </g>
      </g>
  </IconWrapper>
)
